import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  requirements: [],
  manufacturers: [],
  isLoading: false
})

const getters = {
  requirements: (state) => state.requirements,
  manufacturers: (state) => state.manufacturers,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_REQUIREMENTS(state, payload) {
    state.requirements = payload
  },
  SET_MANUFACTURERS(state, payload) {
    state.manufacturers = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchRequirements({ commit, dispatch }) {
    axiosWithToken
      .get(`${adminBaseUrl}/requirements/manufacturer`)
      .then((res) => {
        commit('SET_REQUIREMENTS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
  },
  fetchManufacturers({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)

    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_MANUFACTURERS', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createManufacturer({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/manufacturer`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/manufacturers')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteManufacturer(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/manufacturer/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchManufacturer(_context, { id, vm }) {
    vm.mLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/manufacturer/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.nameEn = message.name_en
        vm.editForm.nameRu = message.name_ru
        vm.editForm.categoryId = message.category_id
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.mLoading = false
      })
  },
  updateManufacturer(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.mLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/manufacturer/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editManufacturerModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.mLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
